import React from 'react'
import { useTranslation } from 'react-i18next'

import ButtonExitImpersonnation from 'components/Buttons/ButtonExitImpersonnation'
import notfound from '../../assets/notfound.png'
import deniedAccess from '../../assets/deniedAccess.png'
import technicalError from '../../assets/technicalError.png'
import headerAvatar from '../../assets/Header-Avatar.png'

interface Props {
  title: string
  description: string | JSX.Element
  type: string
  chatbot?: boolean
  textButton?: string
  externalLink?: string
  countdown?: number | null
}

const ErrorBody: React.FC<Props> = ({
  title,
  description,
  type,
  chatbot,
  textButton,
  externalLink,
  countdown,
}: Props) => {
  const { t } = useTranslation()

  const renderImage = () => {
    switch (type) {
      case 'notFound':
        return notfound
      case 'deniedAccess':
        return deniedAccess
      case 'technicalError':
        return technicalError
      default:
        return notfound
    }
  }
  return (
    <div className="errorbody">
      <img
        src={renderImage()}
        alt="man holding empty box"
        className="errorbody_image"
      />
      <div className="errorbody_text-container">
        <div className="content">
          {title && <h2 className="title">{title}</h2>}
          <div>
            {chatbot && (
              <img
                src={headerAvatar}
                className="img-fluid mb-5"
                alt="header-avatar"
              />
            )}
            <div>{description}</div>
            {chatbot && <p>{t('error.chatbotLabel')}</p>}
          </div>
          <ButtonExitImpersonnation
            textButton={
              countdown !== null
                ? `${textButton || t('error.backHome')} (${countdown})`
                : textButton || t('error.backHome')
            }
            className=""
            externalLink={externalLink}
          />
        </div>
      </div>
    </div>
  )
}

ErrorBody.defaultProps = {
  chatbot: true,
  textButton: undefined,
  externalLink: undefined,
  countdown: null,
}

export default ErrorBody
